const initialBody = {
  document: {
    nodes: [
      {
        object: "block",
        type: "paragraph",
        nodes: [
          {
            object: "text",
            leaves: [
              {
                text: ""
              }
            ]
          }
        ]
      }
    ]
  }
};
const initialUser = {
  id: null,
  name: {
    title: "",
    full: ""
  },
  job_title: "",
  institution: "",
  email: ""
};

module.exports = { initialBody, initialUser };



// WEBPACK FOOTER //
// ./src/stores/initialState.js